import { useEffect, useState, type ReactNode } from 'react';
import { Box, Menu, MenuButton } from '@chakra-ui/react';

/**
 * The menu at a point on screen, around an invisible anchor. It opens one
 * render after mounting: Chakra moves focus into a menu only when `isOpen`
 * changes, and a menu mounted already open would leave focus on the item,
 * where arrow keys and Escape never reach it.
 */
export function PointMenu({
  x,
  y,
  onClose,
  children,
}: {
  x: number;
  y: number;
  onClose: () => void;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => setIsOpen(true), []);
  return (
    <Menu isOpen={isOpen} onClose={onClose} placement="bottom-start" gutter={0}>
      <MenuButton
        as={Box}
        aria-hidden
        tabIndex={-1}
        position="fixed"
        left={`${x}px`}
        top={`${y}px`}
        w={0}
        h={0}
      />
      {children}
    </Menu>
  );
}
